import { Project } from './types';

export const initialProject: Project = {
  id: null,
  name: null,
  customerId: null,
  customer: null,
  accountingClass: null,
  accountingClassId: null,
  accountingId: null,
  startDate: null,
  endDate: null,
  datecreated: null,
  datemodified: null,
  notes: null,
  dateDeleted: null,
  deleted: false,
};
